import { Button, message, Row } from 'antd';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router';
import { ChevronDownIcon } from '../../../../resource/icons';
import BasicInformationLine from '../../components/BasicInformationLine/BasicInformationLine';
import DebtorsList from '../../components/DebtorsList/DebtorsList';
import actions from '../../store/actions/actions';
import getDebtsList from '../../store/thunks/getDebtsList';
import CreateNotice from './components/createNotice/CreateNotice';
import DeleteFile from './components/DeleteFile/DeleteFile';
import Filter from './components/Filter';
import './FileView.scss';
import UpdateFile from './components/UpdateFile/UpdateFile';

const FileView = memo(() => {
  const [filterIsOpened, setFilterOpened] = useState();
  const filter = useSelector((store) => store.debtsStore.filter);
  const filterIsWorked = useSelector(
    (store) => store.debtsStore.filterIsWorked
  );
  const files = useSelector((store) => store.debtsStore.files);
  const dispatch = useDispatch();
  const {
    params: { fileId },
  } = useRouteMatch('/Debts/file/:fileId') || { params: {} };

  const { WorkerId } = useSelector((state) => state.authentication.userInfo);

  const file = files?.find((file) => {
    return Number(file.fileId) === Number(fileId);
  });

  const showBtnActions = Number(WorkerId) === file?.workerId;

  useEffect(() => {
    dispatch(getDebtsList({ fileId }));
  }, [fileId, dispatch]);

  useEffect(() => {
    return () => dispatch({ type: actions.DEBTS_LIST_LOADED, payload: [] });
  }, []);

  useEffect(() => {
    dispatch({
      type: actions.OPENED_FILE,
      payload: files?.find((file) => {
        return Number(file.fileId) === Number(fileId);
      }),
    });
  }, [fileId, files]);

  const onFilterButtonClick = useCallback(() => {
    if (!filterIsWorked) {
      if (Object.values(filter).filter(Boolean).length) {
        dispatch(getDebtsList({ ...filter, fileId }));
      } else {
        if (filterIsOpened) {
          message.info('Укажите данные для фильтрации');
        }
        setFilterOpened(true);
      }
    } else {
      dispatch({ type: actions.DELETE_FILTER });
      dispatch(getDebtsList({ fileId }));
    }
  }, [filterIsWorked, filter, filterIsOpened, fileId]);

  return (
    <div className="file_view-container">
      <div className="file_view-header">
        <div className="file_view-header-filter">
          <Row
            type="flex"
            align="middle"
            justify="space-between"
          >
            <Row
              type="flex"
              align="middle"
              justify="space-between"
              className="file_view-header-filter-active_elements"
              onClick={() => setFilterOpened(!filterIsOpened)}
            >
              <ChevronDownIcon
                className={
                  filterIsOpened ? 'file_view-header-filter-chevron_opened' : ''
                }
              />
              <span>Фильтр</span>
            </Row>
            <span className="file_view-header-filter-feedback">
              Для настройки автообзвона, рассылки e-mail, рассылки СМС или
              <br /> для добавления новых шаблонов рассылки - написать запрос на
              почту support@dispex.ru
            </span>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              {showBtnActions && (
                <>
                  <UpdateFile file={file} />
                  <DeleteFile fileId={fileId} />
                </>
              )}
            </div>
          </Row>
          {filterIsOpened && <Filter fileId={fileId} />}
        </div>
        <BasicInformationLine
          buttons={
            <>
              <Button
                type="primary"
                className="button"
                onClick={onFilterButtonClick}
              >
                {filterIsWorked ? 'Сбросить фильтр' : 'Применить фильтр'}
              </Button>
              <CreateNotice />
            </>
          }
        />
        <div className="file_view-header-sort"></div>
      </div>
      <div className="file_view-list">
        <DebtorsList key="file-debtors" />
      </div>
    </div>
  );
});

export default FileView;
